/** блок адаптации **/
import './common/adapterFromOldStyle'
/** блок адаптации **/
import { lang, sessid } from './common/baseData'

import './tradeIn/style.css'
import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import langData from './components/tradeIn/lang'
import PhoneInputMasked from './components/phoneInputMasked'
import FaqList from './components/faqList/FaqList'
import CityShopList from './components/cityShopList/CityShopList'
import ComponentDataLoader from './components/componentDataLoader/ComponentDataLoader'
import IncludeFileData from './components/includeFileData/IncludeFileData'
import TradeIn from './components/tradeIn/TradeIn'
import {createRoot} from 'react-dom/client';

function TradeInApp (props) {

  function getMessage (message) {
    return langData[props.lang][message] || ''
  }

  return (
    <>
      <section className={'data-wrapper'}>
        <ComponentDataLoader componentParams={props.tradein} lang={props.lang} sessid={props.sessid}>
          <TradeIn sessid={sessid}/>
        </ComponentDataLoader>
      </section>
      <section className={' trade-in-video'}>
        <ComponentDataLoader componentParams={props.video} lang={props.lang} sessid={props.sessid} loader={false}>
          <IncludeFileData/>
        </ComponentDataLoader>
      </section>
      <section className={' trade-in-conditions'}>
        <ComponentDataLoader componentParams={props.conditions} lang={props.lang} sessid={props.sessid} loader={false}>
          <IncludeFileData/>
        </ComponentDataLoader>
      </section>
      <section className={''}>
        <ComponentDataLoader componentParams={props.faq} lang={props.lang} sessid={props.sessid} loader={false}>
          <FaqList/>
        </ComponentDataLoader>
      </section>
      {/*<section className={'data-wrapper'}>*/}
      {/*  <div className={'section-title'}>{getMessage('whereExchange')}</div>*/}
      {/*  <ComponentDataLoader componentParams={props.shops} lang={props.lang} sessid={props.sessid}>*/}
      {/*    <CityShopList/>*/}
      {/*  </ComponentDataLoader>*/}
      {/*</section>*/}
    </>
  )
}

let rootNode = document.getElementById('trade-in-root')

// props
let props = {
  shops: window.shopsParams || {},
  faq: window.faqParams || {},
  conditions: window.conditionsParams || {},
  video: window.videoParams || {},
  tradein: window.tradeinParams || {},
  lang: lang,
  sessid: sessid
}

const appRoot = createRoot(rootNode)
appRoot.render(<TradeInApp {...props}/>)
